import HeightInputMetric from './HeightInputMetric';

export default HeightInputMetric;
